import script from "./SkuHistorySearchPillGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./SkuHistorySearchPillGroup.vue?vue&type=script&setup=true&lang=js"

import "./SkuHistorySearchPillGroup.vue?vue&type=style&index=0&id=980808ea&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-980808ea"]])

export default __exports__